var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ace-editor',{attrs:{"lang":"sql","theme":"chrome","width":"100%","height":"200"},on:{"init":_vm.editorInit},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})}
var staticRenderFns = []

export { render, staticRenderFns }